import React, {ReactElement} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown} from "@fortawesome/pro-solid-svg-icons";
import classes from './Questions.module.scss'
import {Collapse} from "@material-ui/core";
import clsx from "clsx";

interface Props {
	title: string,
	body: string,
	expanded: boolean,
	onClick: () => void
}


export const Question = (props: Props): ReactElement<Props> => {
	return (
		<div className={classes.question}>
			<div className={classes.header} onClick={props.onClick}>
				<h5>{props.title}</h5>
				<div className={classes.iconContainer}>
					<FontAwesomeIcon
						icon={faChevronDown}
						className={clsx(
							classes.icon,
							props.expanded && classes.iconExpanded
						)}
						size='2x'/>
				</div>
			</div>
			<Collapse className={classes.content} in={props.expanded}>
				<p>{props.body}</p>
			</Collapse>
		</div>
	)
}
